import createIcon from '../../createIcon';

/**
 * @component @name MobileOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy4wMjk3NyAyLjQ5TDEuNzU5NzcgMy43Nkw1LjI2OTc3IDcuMjdWMjFDNS4yNjk3NyAyMi4xIDYuMTY5NzcgMjMgNy4yNjk3NyAyM0gxNy4yNjk4QzE4LjI4OTggMjMgMTkuMTE5OCAyMi4yMyAxOS4yNDk4IDIxLjI1TDIwLjk2OTggMjIuOTdMMjIuMjM5OCAyMS43TDMuMDI5NzcgMi40OVpNNy4yNjk3NyAxOVY5LjI3TDE2Ljk5OTggMTlINy4yNjk3N1pNMTcuMjY5OCA1VjE0LjE3TDE5LjI2OTggMTYuMTdWM0MxOS4yNjk4IDEuOSAxOC4zNjk4IDEgMTcuMjY5OCAxSDcuMjY5NzdDNi40MTk3NyAxIDUuNjg5NzcgMS41NCA1LjM5OTc3IDIuM0w4LjA5OTc3IDVIMTcuMjY5OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MobileOff = createIcon('MobileOff', [
  [
    'path',
    {
      d: 'M3.02977 2.49L1.75977 3.76L5.26977 7.27V21C5.26977 22.1 6.16977 23 7.26977 23H17.2698C18.2898 23 19.1198 22.23 19.2498 21.25L20.9698 22.97L22.2398 21.7L3.02977 2.49ZM7.26977 19V9.27L16.9998 19H7.26977ZM17.2698 5V14.17L19.2698 16.17V3C19.2698 1.9 18.3698 1 17.2698 1H7.26977C6.41977 1 5.68977 1.54 5.39977 2.3L8.09977 5H17.2698Z',
      key: '51l5fh',
    },
  ],
]);

export default MobileOff;
